import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getFunctionDetail,
  getFunctionOverview,
  getSinkDetail,
  getSinkOverview,
  getSourceDetail,
  getSourceOverview,
} from '@/services/functionService';

const initialState = {
  fxoverview: {},
  sinkoverview: {},
  sourceoverview: {},
  loading: false,
  detailLoading: false,
  fxDetail: {},
  sourceDetail: {},
  sinkDetail: {},
};

export const fetchFunctionOverview = createAsyncThunk(
  'function/fetchFunctionOverview',
  async (clusterName) => {
    const response = await getFunctionOverview(clusterName);
    return response.data;
  },
);

export const fetchSinkOverview = createAsyncThunk(
  'function/fetchSinkOverview',
  async (clusterName) => {
    const response = await getSinkOverview(clusterName);
    return response.data;
  },
);

export const fetchSourceOverview = createAsyncThunk(
  'function/fetchSourceOverview',
  async (clusterName) => {
    const response = await getSourceOverview(clusterName);
    return response.data;
  },
);

export const fetchFunctionDetail = createAsyncThunk(
  'function/fetchFunctionDetail',
  async (params) => {
    const response = await getFunctionDetail(params);
    return response.data;
  },
);

export const fetchSourceDetail = createAsyncThunk('function/fetchSourceDetail', async (params) => {
  const response = await getSourceDetail(params);
  return response.data;
});

export const fetchSinkDetail = createAsyncThunk('function/fetchSinkDetail', async (params) => {
  const response = await getSinkDetail(params);
  return response.data;
});

export const functionSlice = createSlice({
  name: 'function',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchFunctionOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFunctionOverview.fulfilled, (state, action) => {
        state.fxoverview = action.payload;
        state.loading = false;
      })
      .addCase(fetchFunctionOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchSinkOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSinkOverview.fulfilled, (state, action) => {
        state.sinkoverview = action.payload;
        state.loading = false;
      })
      .addCase(fetchSinkOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchSourceOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSourceOverview.fulfilled, (state, action) => {
        state.sourceoverview = action.payload;
        state.loading = false;
      })
      .addCase(fetchSourceOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchFunctionDetail.pending, (state) => {
        state.detailLoading = true;
      })
      .addCase(fetchFunctionDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.fxDetail = action.payload;
      })
      .addCase(fetchFunctionDetail.rejected, (state) => {
        state.detailLoading = false;
      })
      .addCase(fetchSourceDetail.pending, (state) => {
        state.detailLoading = true;
      })
      .addCase(fetchSourceDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.sourceDetail = action.payload;
      })
      .addCase(fetchSourceDetail.rejected, (state) => {
        state.detailLoading = false;
      })
      .addCase(fetchSinkDetail.pending, (state) => {
        state.detailLoading = true;
      })
      .addCase(fetchSinkDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.sinkDetail = action.payload;
      })
      .addCase(fetchSinkDetail.rejected, (state) => {
        state.detailLoading = false;
      });
  },
});

export default functionSlice.reducer;
